// extracted by mini-css-extract-plugin
export default {"root":"Unavailable-root","logo":"Unavailable-logo","image":"Unavailable-image"};